const COLLECTION_LOAD_MORE_SELECTOR = '[data-load-more]';

const getGridFromButton = (button) => {
  const container = button.closest('[data-collection-grid-container]');
  if (!container) return null;
  return container.querySelector('ul.product-grid');
};

const fetchNextPage = async (button) => {
  if (button.classList.contains('loading')) return;

  const nextPage = Number(button.dataset.nextPage || '2');
  const lastPage = Number(button.dataset.lastPage || '1');
  const sectionId = button.dataset.sectionId;

  if (!sectionId || nextPage > lastPage) {
    button.disabled = true;
    return;
  }

  button.classList.add('loading');

  try {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(nextPage));
    url.searchParams.set('sections', sectionId);

    const result = await fetch(url.href).then((response) => response.json());
    const html = result[sectionId];

    if (!html) throw new Error('Section HTML not found');

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsed.querySelector('ul.product-grid');
    const currentGrid = getGridFromButton(button);

    if (!newGrid || !currentGrid) {
      throw new Error('Product grid not found');
    }

    currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);

    const updatedNextPage = nextPage + 1;
    button.dataset.nextPage = String(updatedNextPage);

    if (updatedNextPage > lastPage) {
      button.disabled = true;
    }
  } catch (error) {
    console.error('[collection-load-more]', error);
  } finally {
    button.classList.remove('loading');
  }
};

const observeAutoLoad = () => {
  document.querySelectorAll(`${COLLECTION_LOAD_MORE_SELECTOR}[data-scroll-loading="true"]`).forEach((button) => {
    if (button.dataset.observeAttached === 'true') return;
    button.dataset.observeAttached = 'true';

    let hasScrolled = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && hasScrolled) {
          fetchNextPage(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0
    });

    const onScroll = () => {
      hasScrolled = true;
      window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    observer.observe(button);
  });
};

document.addEventListener('click', (event) => {
  const button = event.target.closest(COLLECTION_LOAD_MORE_SELECTOR);
  if (!button) return;
  event.preventDefault();
  fetchNextPage(button);
});

document.addEventListener('DOMContentLoaded', observeAutoLoad);
document.addEventListener('filter:update', observeAutoLoad);    